/* eslint-disable react-hooks/rules-of-hooks */
import * as React from 'react';
import { useSelector } from 'react-redux';

import { debounce } from 'throttle-debounce';
import { useActions } from '../useActions';

import { intOnly } from '../../utils/intOnly';

import { selectFormFields, selectEstimationTarget, selectIsFormWithRoomNumberExperiment } from '../../selectors';

import { IRoomNumberInputProps } from '../../../common/utils/types';
import { ECurrentErrorField } from '../../types/formFields';
import { useSubmitAnalyticsFormWithRoomNumber } from '../useSubmitAnalyticsFormWithRoomNumber';

export const useRoomNumberInputProps = (): IRoomNumberInputProps | undefined => {
  const withRoomNumber = useSelector(selectIsFormWithRoomNumberExperiment);

  if (!withRoomNumber) {
    return undefined;
  }

  const estimationTarget = useSelector(selectEstimationTarget);
  const {
    flatNumber,
    flatNumberSuggest: { isSuccess },
    errorTooltip,
    area,
    roomsCount,
  } = useSelector(selectFormFields);
  const { setFlatNumber, getFlatNumberSuggest } = useActions();
  const submitWithRoomsNumberAnalytics = useSubmitAnalyticsFormWithRoomNumber();

  /** Если есть ошибка, отобразится над инпутом фильтра */
  const errorMessage = errorTooltip.currentErrorField === ECurrentErrorField.flatNumber ? errorTooltip.errorText : '';

  const getFlatNumberSuggestDebounced = React.useCallback(debounce(200, getFlatNumberSuggest), []);

  const onBlur = React.useCallback(() => {
    if (isSuccess) {
      submitWithRoomsNumberAnalytics({
        flatNumber,
        area,
        roomsCount,
      });
    }
  }, [isSuccess, flatNumber, roomsCount, area, submitWithRoomsNumberAnalytics]);

  const onValueChange = React.useCallback<IRoomNumberInputProps['onValueChange']>(
    value => {
      const intVal = intOnly(value);

      setFlatNumber(Number(intVal));
      getFlatNumberSuggestDebounced(String(intVal));
    },
    [getFlatNumberSuggestDebounced, setFlatNumber, estimationTarget],
  );

  return {
    value: flatNumber ? String(flatNumber) : '',
    isRoomSuggestSuccess: isSuccess,
    errorMessage,
    onValueChange,
    onBlur,
  };
};
